import React from 'react';
import { Avatar } from 'grommet';
import ProfileImage from 'assets/images/img_avatar.png';

const ProfileIcon = ({ size, img }) => {
  return <Avatar size={size} src={img ? img : ProfileImage} />;
};

export default ProfileIcon;
